//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
import EstadoManager from '../../../Common/Managers/EstadoManager';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

//ACTION TYPES
export const GET_SCREEN_DATA_CONFIRMADOR_SOLICITUD = 'GET_SCREEN_DATA_CONFIRMADOR_SOLICITUD';
export const GET_SCREEN_DATA_RESULTADO_CONFIRMADOR_SOLICITUD = 'GET_SCREEN_DATA_RESULTADO_CONFIRMADOR_SOLICITUD';
export const SET_USER_FUNCTIONS_CONFIRMADOR_SOLICITUD = 'SET_USER_FUNCTIONS_CONFIRMADOR_SOLICITUD';
export const CHANGE_ENTIDAD_CONFIRMADOR_SOLICITUD = 'CHANGE_ENTIDAD_CONFIRMADOR_SOLICITUD';
export const CAMBIAR_ESTADO_SOLICITUD = 'CAMBIAR_ESTADO_SOLICITUD';
export const INITIAL_STATE_CONFIRMADOR_SOLICITUD = 'INITIAL_STATE_CONFIRMADOR_SOLICITUD';
export const OPEN_MODAL_MSG_CONFIRMACION_SOLICITUD = 'OPEN_MODAL_MSG_CONFIRMACION_SOLICITUD';
export const OPEN_MODAL_MSG_DENEGACION_SOLICITUD = 'OPEN_MODAL_MSG_DENEGACION_SOLICITUD';
export const CLOSE_MODAL_CONFIRMADOR = 'CLOSE_MODAL_CONFIRMADOR';

let _vistaCliente, _executionContext;
let _dispatch = null;

/**
 * Action que obtiene el estado inicial.
 * @param {any} currentScope
 */
export function getScreenData(currentScope, sesion) {
    LogHelper.In(getScreenData.name, currentScope, sesion);

    return (dispatch, getState) => {
        let state = getState();
        _vistaCliente = state.vistaCliente;
        _executionContext = sesion.executionContext;
        _dispatch = dispatch;

        dispatch({ type: GET_SCREEN_DATA_CONFIRMADOR_SOLICITUD });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadUserFunctions(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function resetStateConfirmadorSolicitud() {
    LogHelper.In(resetStateConfirmadorSolicitud.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_CONFIRMADOR_SOLICITUD });
    }
}

/**
 * Se dirige a la anterior o siguiente entidad
 * @param {any} entidadAdirijirse
 */
export function goTo(entidadAdirijirse) {
    LogHelper.In(goTo.name, entidadAdirijirse);

    return (dispatch, getState) => {
        dispatch({
            type: CHANGE_ENTIDAD_CONFIRMADOR_SOLICITUD,
            entidadSeleccionada: entidadAdirijirse
        });
    }
}

/**
 * Deniega o confirma la solicitud
 * @param {any} estado
 */
export function cambiarEstado(estado) {
    LogHelper.In(cambiarEstado.name, estado);

    return (dispatch, getState) => {

        _dispatch = dispatch;

        let callBack;
        switch (estado) {
            case 3:
                callBack = mostrarConfirmacion;
                break;
            case 4:
                callBack = mostrarDenegacion;
                break;
        }
        EstadoManager.CambiarEstadoSolicitud(_vistaCliente.data.solicitudId, _executionContext, estado, callBack);
    }
}

/**
 * Cierra el modal.
 */
export function cerrarModal() {
    LogHelper.In(cerrarModal.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CLOSE_MODAL_CONFIRMADOR });
    }
}

/*-----------------------------------------FUNCIONES AUXILIARES-----------------------------------------*/

/**
 * Funcion callback que establece los permisos que tiene el usuario sobre la pantalla y/o componentes
 * @param { any } data Parametro injectado desde la funcion callback, contiene un string de los permisos del usuario
 */
function _loadUserFunctions(data) {
    LogHelper.In(_loadUserFunctions.name, data);

    let functions = data.CONSULTASOCIOS;
    let functionsAllowed = {}

    functions.forEach(p => { functionsAllowed[p.Codigo_Funcion] = true; });
    _dispatch({ type: SET_USER_FUNCTIONS_CONFIRMADOR_SOLICITUD, functions: functionsAllowed });

    _getScreenData();
}

/**
 * 
 */
function _getScreenData() {
    LogHelper.In(_getScreenData.name);

    let parametro = {
        'CUIT': _vistaCliente.data.client.Cuit
    }
    let parametrosCategoriaIva = {
        'CATEGORIA_IVA_ID': _vistaCliente.data.client.CategoriaIVA.Id
    };

    //Carga toda la informacion para el store de Tarjetas.
    LogHelper.Out(_getScreenData.name, parametro, 'GET_EMPRESA_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_EMPRESA_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    LogHelper.Out(_getScreenData.name, parametro, 'GET_CUENTA_TARJETA_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_CUENTA_TARJETA_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    LogHelper.Out(_getScreenData.name, parametro, 'GET_CUENTA_TARJETA_VISA_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_CUENTA_TARJETA_VISA_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    LogHelper.Out(_getScreenData.name, parametro, 'GET_CUENTA_TARJETA_INFO_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_CUENTA_TARJETA_INFO_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    LogHelper.Out(_getScreenData.name, parametrosCategoriaIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametrosCategoriaIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.Execute(_loadScreenData, null, null, "CONSULTASOCIOS");
}

/**
 * 
 * @param {any} data
 */
function _loadScreenData(data) {

    let solicitudId = _vistaCliente.data.solicitudId;
    LogHelper.In(_loadScreenData.name, data);

    let empresas = JSON.parse(data.GET_EMPRESA_CUIT).Recordset0.Rows;

    let tarjetasVisa = JSON.parse(data.GET_CUENTA_TARJETA_VISA_BY_CUIT).Recordset1.Rows;
    let cuentasTarjetasVisa = JSON.parse(data.GET_CUENTA_TARJETA_VISA_BY_CUIT).Recordset0.Rows;

    let tarjetas = JSON.parse(data.GET_CUENTA_TARJETA_BY_CUIT).Recordset1.Rows.map((tc) => {
        return Object.assign({}, tc, tarjetasVisa.find((tcv) => tcv.TarjetaCreditoId == tc.Id));
    });

    let cuentas = JSON.parse(data.GET_CUENTA_TARJETA_BY_CUIT).Recordset0.Rows.map((ct) => {
        ct.CantTarjetasCredito = tarjetas.filter((te) => te.CuentaTarjetaId == ct.Id).length;
        return Object.assign({}, ct, cuentasTarjetasVisa.find((ctv) => ctv.CuentaTarjetaId == ct.Id));
    });

    let solicitud = _vistaCliente.data.GET_SOLICITUD_EN_CURSO_BY_CLIENTE.find(x => x.Numero == solicitudId);

    let resultado = {

        'razonSocial': _vistaCliente.data.client.RazonSocial,
        'empresa': empresas.find(x => x.Id == solicitud.EmpresaVisaId),
        'cuentas': cuentas.filter(x => x.Id == solicitud.CuentaTarjetaId),
        'tarjetas': tarjetas.filter(x => x.SolicitudId == solicitudId),
        'atlasCategoriaIva': JSON.parse(data.GET_CATEGORIA_IVA_BY_ID).Recordset0.Rows[0],
        'cuentasInfo': JSON.parse(data.GET_CUENTA_TARJETA_INFO_BY_CUIT).Recordset0.Rows,
        'rubros': [],
        'empresaSolicitud': false,
        'cuentaSolicitud': false,
    }

    //Empresa Aceptada por Administradora, no se visualiza
    resultado.empresaSolicitud = resultado.empresa.SolicitudEstado == 9 ? true : resultado.cuentas[0].SolicitudEstado == 10 ? true : false;
    if (!resultado.empresaSolicitud) {
        resultado.empresaSolicitud = resultado.empresa.SolicitudId != solicitudId;
    }
    _getEnterpriceRubros(resultado, solicitudId);
}

/**
 * 
 * @param {any} resultado
 * @param {any} solicitudId
 */
function _getEnterpriceRubros(resultado, solicitudId) {
    let param = {
        'EMPRESA_ID': parseInt(resultado.empresa.Id)
    }

    Engine1Proxy.AddDataSourcesRequests(param, 'GET_RUBROS_BY_EMPRESA_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    LogHelper.Out(_getEnterpriceRubros.name, param, 'GET_RUBROS_BY_EMPRESA_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.Execute((data) => _loadEnterpriceRubros(data, resultado, solicitudId), null, resultado.empresa.Id, "SOLICITUD");
}

/**
 * 
 * @param {any} resultado
 * @param {any} cuentaInfoSeleccionada
 */
function mapearCuenta(resultado, cuentaInfoSeleccionada) {

    resultado.cuentas[0].DomicilioCorrespondencia = resultado.cuentas[0].DomicilioCorrespondenciaBancoTipo + " - " +
        resultado.cuentas[0].DomicilioCorrespondenciaCalle + ", " +
        resultado.cuentas[0].DomicilioCorrespondenciaNumero + ", " +
        resultado.cuentas[0].DomicilioCorrespondenciaDepartamentoPartido + ", " +
        resultado.cuentas[0].DomicilioCorrespondenciaLod + ", " +
        resultado.cuentas[0].DomicilioCorrespondenciaCodigoPostal + ", " +
        "(" + "Cód. geográfico " + (resultado.cuentas[0].DomicilioCorrespondenciaCodigoGeografico != "0" ? resultado.cuentas[0].DomicilioCorrespondenciaCodigoGeografico : resultado.cuentas[0].DomicilioCorrespondenciaCodigoGeograficoInput) + ")" +
        ". (Telefono " + (resultado.cuentas[0].Caracteristica || "") + " " + resultado.cuentas[0].Telefono + " )";

    resultado.cuentas[0].DomicilioParticular = resultado.cuentas[0].DomicilioParticularBancoTipo + " - " +
        resultado.cuentas[0].DomicilioParticularCalle + ", " +
        resultado.cuentas[0].DomicilioParticularNumero + ", " +
        resultado.cuentas[0].DomicilioParticularDepartamentoPartido + ", " +
        resultado.cuentas[0].DomicilioParticularLod + ", " +
        resultado.cuentas[0].DomicilioParticularCodigoPostal + ", " +
        "(" + "Cód. geográfico " + (resultado.cuentas[0].DomicilioParticularCodigoGeografico != "0" ? resultado.cuentas[0].DomicilioParticularCodigoGeografico : resultado.cuentas[0].DomicilioParticularCodigoGeograficoInput) + ")" +
        ". (Telefono " + (resultado.cuentas[0].Caracteristica || "") + " " + resultado.cuentas[0].Telefono + " )";

    resultado.cuentas[0].Producto = cuentaInfoSeleccionada.Producto;
    resultado.cuentas[0].CuentaTarjetaDescripcion = cuentaInfoSeleccionada.CuentaTarjetaDescripcion;
    resultado.cuentas[0].ModeloLiquidacion = cuentaInfoSeleccionada.ModeloLiquidacion;
    resultado.cuentas[0].Afinidad = cuentaInfoSeleccionada.Afinidad;
    resultado.cuentas[0].ModalidadDistribucionLimite = cuentaInfoSeleccionada.ModalidadDistribucionLimite;
    resultado.cuentas[0].Agrupamiento = cuentaInfoSeleccionada.Agrupamiento;
    resultado.cuentas[0].FormaDePago = cuentaInfoSeleccionada.FormaDePago;
    resultado.cuentas[0].SucursalDescripcion = cuentaInfoSeleccionada.SucursalDescripcion;
    resultado.cuentas[0].Promotor = cuentaInfoSeleccionada.Promotor;
    resultado.cuentas[0].LineaPrestamoVisaDescripcion = cuentaInfoSeleccionada.LineaPrestamoVisaDescripcion;
    resultado.cuentas[0].CategoriaCajeroVisa = cuentaInfoSeleccionada.CategoriaCajeroVisa;

}

/**
 * 
 * @param {any} resultado
 */
function mapearTarjetas(resultado) {
    resultado.tarjetas.forEach(function (tarjeta) {
        let cuenta = resultado.cuentas.find(x => x.CuentaTarjetaId == tarjeta.CuentaTarjetaId);
        tarjeta.CuentaValor = cuenta ? cuenta.Valor : 0;
    });

    _dispatch({
        type: GET_SCREEN_DATA_RESULTADO_CONFIRMADOR_SOLICITUD,
        resultado: resultado
    });
}


/**
 * 
 * @param {any} data
 * @param {any} resultado
 * @param {any} solicitudId
 */
function _loadEnterpriceRubros(data, resultado, solicitudId) {
    LogHelper.In(_loadEnterpriceRubros.name, data, resultado, solicitudId);
    let rubros = JSON.parse(data.GET_RUBROS_BY_EMPRESA_ID).Recordset0.Rows[0];

    resultado.rubros = [];

    if (rubros != undefined) {
        addRubro(resultado, rubros.RUBRO1);
        addRubro(resultado, rubros.RUBRO2);
        addRubro(resultado, rubros.RUBRO3);
        addRubro(resultado, rubros.RUBRO4);
        addRubro(resultado, rubros.RUBRO5);
        addRubro(resultado, rubros.RUBRO6);
        addRubro(resultado, rubros.RUBRO7);
        addRubro(resultado, rubros.RUBRO8);
        addRubro(resultado, rubros.RUBRO9);
    }

    let cuentaInfoSeleccionada = resultado.cuentasInfo.find(x => x.Id == resultado.cuentas[0].Id);
    //Empresa y Cuenta Aceptada por Administradora, no se visualizan
    resultado.cuentaSolicitud = resultado.cuentas[0].SolicitudEstado == 10 ? true : false
    if (!resultado.cuentaSolicitud) {
        resultado.cuentaSolicitud = resultado.cuentas[0].SolicitudId != solicitudId;
    }
    mapearCuenta(resultado, cuentaInfoSeleccionada);

    mapearTarjetas(resultado);
}

/**
 * 
 * @param {any} resultado
 * @param {any} rubro
 */
function addRubro(resultado, rubro) {
    if (rubro != null) {
        resultado.rubros.push({ "Descripcion": rubro });
    }
}

/**
 * 
 */
function mostrarConfirmacion() {
    _dispatch({
        type: OPEN_MODAL_MSG_CONFIRMACION_SOLICITUD
    });
}

/**
 * 
 */
function mostrarDenegacion() {
    _dispatch({
        type: OPEN_MODAL_MSG_DENEGACION_SOLICITUD
    });
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/ConfirmadorSolicitud/actions/Actions.js